// extracted by mini-css-extract-plugin
module.exports = {"title":"FaqList_title__2CL1A","list":"FaqList_list__bQnOf","tutorialLink":"FaqList_tutorialLink__1u1MB","deprecated":"FaqList_deprecated__13rh7"};